import { api, ApiError } from './api';
export type ChannelReceipt = { id: string; channel: string; sequence: number; status: string; receiptKind: string; receiptRef?: string; receiptNote?: string; releasedAt?: string; withdrawnAt?: string };
export type PortalChannel = { channelKey: string; title: string; enabled: boolean; version: number; disabledReason?: string };
export type PortalChannels = { items: PortalChannel[]; figuresActivated: boolean; placeholderRef: string };
export const listPortalChannels = () => api<PortalChannels>('/api/v1/portal-channels');
export const listPortalReceipts = (id: string) => api<{ items: ChannelReceipt[] }>(`/api/v1/portal-contents/${encodeURIComponent(id)}/releases`);
export function portalError(error: unknown) {
  if (error instanceof ApiError) {
    if (error.reasonCode === 'SNAPSHOT_NOT_READY') return '公开指标快照尚未齐备，请先计算基础指标并核对结果。';
    if (error.reasonCode === 'NOT_ACTIVATED') return '公开渠道尚未开通，请核对对应的激活依据。';
    if (error.reasonCode === 'SUBJECT_CONSENT_REQUIRED') return '请填写本人同意依据后再送审。';
    if (error.reasonCode === 'CHANNEL_DISABLED') return '该栏目已停用，请核对栏目设置。';
  }
  return '暂时无法完成，请重新读取后重试。';
}

// WO-106: staff commands only; each requires recent reauthentication on the API.
export const screenChannelPath = (id: string, action: 'release' | 'withdraw') => `/api/v1/portal-contents/${encodeURIComponent(id)}/channels/SCREEN/${action}`;
